import { Serializable } from '@admin/core/models/serializable';

export class CustomerBrandingViewModel
  implements Serializable<CustomerBrandingViewModel>
{
  fromObject(object: any): CustomerBrandingViewModel {
    Object.assign(this, object);

    return this;
  }

  toObject() {
    return {
      CustomerBrandingId: this.customerBrandingId,
      CustomerId: this.customerId,
      IsActive: this.isActive,
      AnnouncementDesktopBgImage: this.announcementDesktopBgImage,
      AnnouncementMobileBgImage: this.announcementMobileBgImage,
      CustomerCoverImage: this.customerCoverImage,
      AnnouncementDesktopBgImageUrl: this.announcementDesktopBgImageUrl,
      AnnouncementMobileBgImageUrl: this.announcementMobileBgImageUrl,
      CustomerCoverImageUrl: this.customerCoverImageUrl,
      AnnouncementDetailsBgColor: this.announcementDetailsBgColor,
      AnnouncementListColor: this.announcementListColor,
      IsWithOwnAnnouncement: this.isWithOwnAnnouncement,
    };
  }

  public customerBrandingId: number;
  public customerId: number;
  public isActive: boolean;
  public announcementDesktopBgImage: string;
  public announcementMobileBgImage: string;
  public customerCoverImage: string;
  public announcementDesktopBgImageUrl: string;
  public announcementMobileBgImageUrl: string;
  public customerCoverImageUrl: string;
  public announcementDetailsBgColor: string;
  public announcementListColor: string;
  public isWithOwnAnnouncement: boolean;

  constructor() {}
}
